// frontend/src/hooks/useGridPagination.js
//
// The props of a paginated grid: AG Grid's own pagination bar, `pageSize` rows
// a page, with no page size picker, and its numbers written the way the
// merchant's region writes them. Spread the result onto <AgGridReact/>. A
// server-side grid takes these from useSsrmGrid's `pagination` instead, which
// adds the matching cache block size.
//
// The bar's words come from utils/gridLocale.js.

import { useMemo } from 'react';
import { useFormatters } from './useFormatters';

export function useGridPagination(pageSize) {
  const { formatNumber } = useFormatters();
  return useMemo(() => ({
    pagination: true,
    paginationPageSize: pageSize,
    paginationPageSizeSelector: false,
    paginationNumberFormatter: ({ value }) => formatNumber(value, 0),
  }), [pageSize, formatNumber]);
}
